<template>
  <div class="login-dashboard-style">
      <div class="card-header" />
            <div
              v-if="error"
              class="alert alert-danger"
            >
              {{ error }}
            </div>
            <div class="login-Container">
              <div class="login-header">
                <img class="login-header-logo"
                      src="https://firebasestorage.googleapis.com/v0/b/baoopilotapp.appspot.com/o/baooLogos%2FLogoBaooHomepage.png?alt=media&token=4de3eb45-8bb9-4836-8b5e-344b370f3177"
                 >
              </div>
            <div class="login-Form">
              <div class="headline-text">
                  HERSTELLER LOGIN
              </div>
              <div class="headline-subtext">
                  Mit baoo Zugangsdaten anmelden
              </div>
              <form
                action="#"
                @submit.prevent="submit"
              >
                <div class="login-inputSection">
                  <div>
                    <input
                      id="email"
                      v-model="form.email"
                      type="email"
                      class="login-inputSectionInputField"
                      placeholder="MAIL"
                      name="email"
                      value
                      required
                      autofocus
                    >
                  </div>
                </div>
                <div class="login-inputSection">
                  <div>
                    <input
                      id="password"
                      v-model="form.password"
                      type="password"
                      class="login-inputSectionInputField"
                      placeholder="PASSWORT"
                      name="password"
                      required
                    >
                  </div>
                </div>
                

                <div class="loginsubmit">
                  <button
                    type="submit"
                    class="loginsubmitbutton"
                  >
                    anmelden
                  </button>
                </div>
              </form>
              
              <div class="passwordForgotten">
                  <button  v-on:click="resetTextfieldIsShown = true, passwordForgottenText='Passwort vergessen ? Hier klicken. '" class="passwordReset"> {{ passwordForgottenText }}</button>
              </div>
              <div class="login-inputSection"> 
              <form action="" v-if="resetTextfieldIsShown">
                <input
                      v-model="emailForReset"
                      type="email"
                      class="resetPasswordEmailField"
                      placeholder="enter E-MAIL"
                      name="emailreset"
                      value
                    >
              </form>
              <button class="resetPasswordButton" v-if="resetTextfieldIsShown" v-on:click="resetPassword">E-Mail anfordern</button>
              </div>
            </div>
      </div>
  </div>
</template>

<script>
    import firebase from "firebase";

    export default {
        data() {
            return {
                form: {
                    email: "",
                    password: ""
                },
                error: null,
                passwordForgottenText: "Passwort vergessen ? Hier klicken. ",
                resetTextfieldIsShown: false,
                emailForReset: "",
            };
        },
        methods: {
            submit() {
                firebase
                    .auth()
                    .signInWithEmailAndPassword(this.form.email, this.form.password)
                    // eslint-disable-next-line no-unused-vars
                    .then(() => {
                        this.$router.replace({name: "Dashboard"});
                    })
                    .catch(err => {
                        this.error = err.message;
                    });
            },
            
            resetPassword() {
             
              firebase
                .auth()
                .sendPasswordResetEmail(this.emailForReset)
                .then(() =>  {
                    this.passwordForgottenText ='in wenigen Minuten erhalten Sie eine Email um Ihr Passwort neu zu erstellen'
                    this.resetTextfieldIsShown = false 
                    this.emailForReset =''
                  }).catch((error) =>  {
                    console.log(error);
                  });
            },
        }
    };
</script>

<style scoped>
  .login-dashboard-style {
    
    background-color: #2B2C2B;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #2B2C2B;
    z-index: 10;
    
  }
  .login-header{
    background-color: #2B2C2B;
    height: 75px;
    text-align: center;
  }
  .login-header-logo{
    width: 125px;
    height: 49px;
  }
  .login-Container {
    margin: auto;
    width: 270px;
    margin-top: 150px;
    
  }
  .login-Form{
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
      background-color: #ffffff;
      border-radius: 8px;
      height: 340px;
  }
  
  .headline-text
  {
    padding-top: 50px;
    text-align: center;
    font-family: 'Exo', sans-serif;
    font-weight: bolder;
  }
  .headline-subtext
  {
    padding-top: 5px;
    text-align: center;
    font-family: 'Exo', sans-serif;
    font-size: 11px;
    color: #ADADAD;
    padding-bottom: 15px;
  }
  .login-inputSection
  {
    text-align: center;
    overflow: hidden;
    margin-top: 10px;
    margin-bottom: 10px;
  } 

  .login-inputSectionInputField
  {
    margin: auto;
    padding : 10px;
    width: 65%;
    height: 34px;
    border: solid 1px;
    font-family: 'Exo', sans-serif;
    border-radius: 17px;
    border-color: #ebebeb;
    background-color: white;
  } 
  .passwordForgotten
  {
    padding-top: 10px;
    text-align: center;
    font-family: 'Exo', sans-serif;
    font-size: 8px;
    color: #ADADAD;
  }
  .loginsubmit
  {
    margin-top: 20px;
    
    text-align: center;
  }
  .loginsubmitbutton
  {
    background-image:linear-gradient(400deg, #ff7600, #fa9842);
    font-family: 'Exo', sans-serif;
    border-radius:18px;
    border-width: 0px;
    height: 36px;
    color: white;
    font-weight: bold;
    font-size: 9px;
    width: 65%;
   
  }
  .passwordReset{
    font-family: 'Exo', sans-serif;
    border-width: 0px;
    color: black;
    font-weight: bold;
    font-size: 7px;
    width: 65%;
    background-color: white;
  }
  .resetPasswordEmailField{
    margin: auto;
    padding : 10px;
    width: 55%;
    height: 20px;
    border: solid 1px;
    font-family: 'Exo', sans-serif;
    
    border-color: #ebebeb;
    background-color: white;
  }

  .resetPasswordButton{
    background-image:linear-gradient(400deg, #ff7600, #fa9842);
    font-family: 'Exo', sans-serif;
    
    border-width: 0px;
    height: 20px;
    
    font-weight: bold;
    font-size: 7px;
    width: 55%;
  }

</style>